import { useQuery } from '@tanstack/react-query';
import { AvatarDataType, axiosInstance } from '../../utils';

type Payload = {
  id: string;
};

const getAvatarById = async (payload: Payload): Promise<AvatarDataType> => {
  const res = await axiosInstance.get(`/api/avatars/${payload.id}`);
  return res.data;
};

export const usegetAvatarById = (payload: Payload) => {
  return useQuery(['getAvatarById', payload], () => getAvatarById(payload));
};
